import { z } from 'zod';

export const AccessSearchSchema = z.object({ code: z.string().optional() });

export type AccessSearchSchemaType = z.infer<typeof AccessSearchSchema>;
